import { Routes, Route, Navigate } from "react-router-dom";
import { useConcatArrays } from "../utils/useTools";
import { ReactNode } from "react";
import { RoutersType } from "../type/routes";
import Error404 from "../pages/errorPage/error";
import { routes as houjinRoutes } from "./houjinPagesDef";
import { routes as commonRoutes } from "./common";
import { routes as daikoshaRoutes } from "./daikoshaPagesDef";
import { routes as kikoSyokuinRoutes } from "./kikoSyokuinPagesDef";
import { routes as taisyokushaRoutes } from "./taisyokushaPagesDef";
import { routes as todofukenRoutes } from "./todofukenPagesDef";
// todo ここにルーティングを追加していく
export const useConcatRoutes = () => {
  const RouterArray = useConcatArrays(
    houjinRoutes,
    commonRoutes,
    daikoshaRoutes,
    kikoSyokuinRoutes,
    taisyokushaRoutes,
    todofukenRoutes
  );
  return RouterArray;
};

const generateRoute = (routes: RoutersType[]): ReactNode => {
  return routes.map((route) => (
    <Route path={route.path} Component={route.component} key={route.path}>
      {route.child && generateRoute(route.child)}
    </Route>
  ));
};

const TkRouters = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/SCRC010001" />} />

      {generateRoute(useConcatRoutes())}

      <Route path="*" Component={Error404} />
    </Routes>
  );
};

export default TkRouters;
